module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-5.bff8074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/geotap-game-lucre-games-ios-android-casual-mobile-game-promo-5.png
// module id = R+Vo
// module chunks = 0